module.exports = __webpack_public_path__ + "img/xml.fb9ae02c.svg";